import { memo } from "react";
import WarehouseDropdown from "ui/components/Dropdown/WarehouseDropdown/WarehouseDropdown";
import { DatePicker } from "ui/components/DatePicker";
import { useHandleDateChange, useHandleDropdownChange, useHandleNumberFieldChange } from "services/forms/hooks";
import { FleetTireSetUsage } from "services/api/fleet/tires/types";
import TireSetKmField from "ui/modules/fleet/tires/pages/components/TireSetKmField/TireSetKmField";
import { Errors } from "services/forms/validation/types";
import { DemountFormValues } from "../types";

interface DemountStep1Props {
  formValues: DemountFormValues;
  setFormValues: React.Dispatch<React.SetStateAction<DemountFormValues>>;
  errors: Errors;
  openUsage: FleetTireSetUsage | null;
  vehicleKm: number | null;
}

const DemountStep1: React.FC<DemountStep1Props> = ({ formValues, setFormValues, errors, openUsage, vehicleKm }) => {
  const handleDateChange = useHandleDateChange(setFormValues, formValues);
  const handleDropdownChange = useHandleDropdownChange(setFormValues, formValues);
  const handleNumberFieldChange = useHandleNumberFieldChange(setFormValues, formValues);

  return (
    <div className="flex items-center justify-center px-4 min-h-[70vh] 2xl:min-h-[1000px]">
      <div className="w-full max-w-2xl">
        <h1 className="text-2xl font-bold text-slate-900 text-center mb-1 mb-2">Odaberite skladište</h1>
        <p className="text-center text-md text-slate-500 mb-8">
          Na koje skladište želite spremiti demontirani set guma?
        </p>

        <div className="border bg-white border-slate-200">
          <div className="border-b border-slate-200 py-6 px-4">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-xs uppercase tracking-wide text-slate-400 font-semibold">Odredište</h3>
              <p className="text-xs text-slate-500">Kamo se sprema demontirani set</p>
            </div>
            <div>
              <div>
                <WarehouseDropdown
                  name="targetWarehouseId"
                  label="Skladište"
                  placeholder="Odaberite skladište..."
                  value={formValues.targetWarehouseId}
                  onChange={handleDropdownChange}
                  error={errors.targetWarehouseId}
                  required
                />
              </div>
            </div>
          </div>
          <div className="py-6 px-4">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-xs uppercase tracking-wide text-slate-400 font-semibold">Datum i kilometraža</h3>
              <p className="text-xs text-slate-500">Kada su gume skinute i stanje brojača vozila</p>
            </div>
            <TireSetKmField
              value={formValues.kmTraveled}
              onChange={handleNumberFieldChange}
              error={errors.kmTraveled}
              vehicleKm={vehicleKm}
              mountKm={openUsage?.mountKm ?? null}
            >
              <div>
                <DatePicker
                  name="transferDate"
                  label="Datum demontaže"
                  placeholder="Odaberite datum..."
                  onChange={handleDateChange}
                  error={errors.transferDate}
                  value={formValues.transferDate}
                  width="full"
                  required
                />
              </div>
            </TireSetKmField>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(DemountStep1);
